import React, { createContext, useContext } from 'react';

/** Application state per job ID (e.g. from SSR/island view model) so first paint shows interviewing/offer/rejected/hired. */
const InitialApplicationStateContext = createContext<Record<string, string | null> | undefined>(undefined);

export function useInitialApplicationStateByJobId(): Record<string, string | null> | undefined {
  return useContext(InitialApplicationStateContext);
}

export const InitialApplicationStateProvider = InitialApplicationStateContext.Provider;
